module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_06_1000.55c30924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_06_1000.jpg
// module id = 340
// module chunks = 0